// track the type of document we're supposed to capture

import { createSlice } from "@reduxjs/toolkit";

export const documentTypeSlice = createSlice({
  name: "documentType",
  initialState: {
    value: null,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = null;
    },
  },
});

export const { update, reset } = documentTypeSlice.actions;

export default documentTypeSlice.reducer;
